import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as userApi from '../../lib/api/user';

const [LIST_USERS, LIST_USERS_SUCCESS, LIST_USERS_FAILURE] =
  createRequestActionTypes('user/LIST_USERS');
export const listUsers = createAction(LIST_USERS, (searchData) => searchData);
const listUsersSaga = createRequestSaga(LIST_USERS, userApi.getUsers);

const UNLOAD_USERS = 'user/UNLOAD_USERS';
export const unloadUsers = createAction(UNLOAD_USERS);

export function* usersSaga() {
  yield takeLatest(LIST_USERS, listUsersSaga);
}

const initialState = {
  users: null,
  error: null,
};

const users = handleActions(
  {
    [LIST_USERS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      users: data.list.map((user) => ({
        id: user.usrUuid,
        usrUuid: user.usrUuid,
        usrNm: user.usrNm,
        emlAddr: user.emlAddr,
        telNo: user.telNo,
        postAddrTxt: user.postAddrTxt,
        postAddrNm: user.postAddrNm,
        dptNm: user.dptNm,
        gradeNm: user.gradeNm,
        profileImg: user.profileImg,
        gender: user.gender,
        useYn: user.useYn,
      })),
      error: null,
    }),
    [LIST_USERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_USERS]: (state) => ({
      ...state,
      users: null,
      error: null,
    }),
  },
  initialState,
);

export default users;
